import React from 'react';
import { Navigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import { DEFAULT_ROUTE } from 'variables';
import { FullScreenSpinner } from 'components/FullScreen';
import { PermissionRequirement } from 'permissions';
import useIsPermitted from './hooks/useIsPermitted';

type ProtectedRouteProps = {
  requiredPermissions: PermissionRequirement[];
  redirectTo?: string;
  fallbackComponent?: React.ReactNode;
  children: any;
};

const defaultRoute = <Navigate to={DEFAULT_ROUTE} />;

const ProtectedRoute = ({
  requiredPermissions,
  fallbackComponent = defaultRoute,
  children,
}: ProtectedRouteProps) => {
  const { isPermitted, status } = useIsPermitted(requiredPermissions);
  const { t } = useTranslation();

  if (status === 'pending') {
    return <FullScreenSpinner message={t('ui.event-management.loading')} />;
  }

  if (!isPermitted) {
    return fallbackComponent;
  }

  return children;
};

export default ProtectedRoute;
